import React, { Suspense, lazy } from 'react';

import AppRouter from './routes';

import { SentryUserSync } from '@/components/SentryUserSync';
import { TooltipProvider } from '@/components/ui/tooltip';
import { AnalyticsProvider } from '@/contexts/AnalyticsContext';
import { BrandKitProvider } from '@/contexts/BrandKitContext';
import { ChatProvider } from '@/contexts/ChatContext';
import { IntegrationProvider } from '@/contexts/IntegrationContext';
import { useStartupCheck } from '@/hooks/useStartupCheck';

// Defer the Sonner toaster off the first-paint entry chunk. Toasts only appear
// on user interaction (well after load), so the toaster doesn't need to be in
// the critical boot graph. Isolated Suspense → never blocks the app tree.
const Sonner = lazy(() => import('@/components/ui/sonner').then((m) => ({ default: m.Toaster })));

const App = () => {
  useStartupCheck();

  return (
    <TooltipProvider delayDuration={200}>
      <IntegrationProvider>
        <BrandKitProvider>
          <ChatProvider>
            <AnalyticsProvider>
              <SentryUserSync />
              <Suspense fallback={null}>
                <Sonner />
              </Suspense>
              <AppRouter />
            </AnalyticsProvider>
          </ChatProvider>
        </BrandKitProvider>
      </IntegrationProvider>
    </TooltipProvider>
  );
};

export default App;
